import React from 'react';
import {Mask} from 'antd-mobile';
import styles from './index.module.scss';
import cancelImg from '@/assets/img/collectionSynthesis/cencall@2x.png';
import confirmImg from '@/assets/img/collectionSynthesis/confirm@2x.png';
import confirmOkImg from '@/assets/img/collectionSynthesis/confirm2@2x.png';
import {COMPOSE_MODE_FIXED, COMPOSE_MODE_RANDOM, formatReservedCount} from '../../utils';

const ConfirmModal = ({
  visible,
  success = false,
  composeMode = '',
  randomCount = '',
  materials = [],
  result = {},
  onCancel,
  onConfirm,
}) => {
  if (!visible) return null;

  const isRandomMode = composeMode === COMPOSE_MODE_RANDOM;
  const isFixedMode = composeMode === COMPOSE_MODE_FIXED;
  const imageClass = materials.length > 4
    ? styles.imagesEight
    : materials.length === 3
      ? styles.imagesThree
      : '';

  return (
    <Mask className={styles.mask} visible={visible} onMaskClick={success ? undefined : onCancel}>
      <div className={styles.wrap}>
        <div className={styles.box}>
          <p className={`${styles.title} ${success ? styles.titleSuccess : ''}`}>
            {success ? '合成成功' : '合成藏品'}
          </p>
          {success ? (
            <>
              <img className={styles.resultImg} src={result.nftImage || result.nftImageUrl} alt="" />
              <p className={styles.label}>藏品编号</p>
              <p className={styles.no}>
                {String(result.nftNo || '')
                  .split(',')
                  .map((item) => item.trim())
                  .filter(Boolean)
                  .map((item) => (item.startsWith('#') ? item : `#${item}`))
                  .join(' ') || '-'}
              </p>
              <img className={styles.okBtn} src={confirmOkImg} alt="确认" onClick={onConfirm} />
            </>
          ) : (
            <>
              <p className={styles.des}>
                {isRandomMode
                  ? `以下藏品将随机销毁${formatReservedCount(randomCount)}个，确定藏品合成？合成操作不可逆`
                  : '确定将以下藏品合成？合成后以下藏品将被回收，且操作不可逆'}
              </p>
              <div className={`${styles.images} ${imageClass}`}>
                {materials.map((item, index) => (
                  <div className={styles.imageWrap} key={item.slotKey || item.nftNo || index}>
                    <img src={item.nftImageUrl || item.nftImage || item.imageBg} alt="" />
                    {isFixedMode && Number(item.count) > 0 ? (
                      <span className={styles.count}>{formatReservedCount(item.count)}</span>
                    ) : null}
                  </div>
                ))}
              </div>
              <div className={styles.btns}>
                <img src={cancelImg} alt="取消" onClick={onCancel} />
                <img src={confirmImg} alt="确认合成" onClick={onConfirm} />
              </div>
            </>
          )}
        </div>
      </div>
    </Mask>
  );
};

export default ConfirmModal;
